<template>
  <main class="gallery-home">
    <section class="album-hero" aria-labelledby="album-hero-title">
      <div class="album-hero__heading">
        <p><span></span> Nachtschicht Schortens</p>
        <h1 id="album-hero-title">Nächte, die <em>bleiben.</em></h1>
      </div>

      <div class="album-hero__grid" :class="{ 'is-loading': loading }">
        <template v-if="loading">
          <div class="album-hero__panel album-hero__placeholder" v-for="index in 4" :key="'loading-' + index">
            <div class="album-hero__skeleton"></div>
          </div>
        </template>
        <router-link
          v-else
          v-for="(gallery, index) in featuredGalleries"
          :key="gallery.id"
          :to="'/gallery/' + gallery.id + '/0'"
          class="album-hero__panel"
          v-lazyload
        >
          <img class="image__item" :data-url="gallery.thumbnaillink" :alt="gallery.name">
          <div class="album-hero__shade"></div>
          <span class="album-hero__number">0{{ index + 1 }}</span>
          <div class="album-hero__content">
            <p>{{ formatDate(gallery.created_at) }}</p>
            <h2>{{ gallery.name }}</h2>
            <span class="album-hero__cta">Album ansehen <b>→</b></span>
          </div>
        </router-link>
      </div>
    </section>

    <div class="album-ticker" aria-hidden="true">
      <div>
        <span>Fotoalben <b>✦</b></span>
        <span>Clubnächte <b>✦</b></span>
        <span>Beste Momente <b>✦</b></span>
        <span>Nachtschicht Schortens <b>✦</b></span>
        <span>Fotoalben <b>✦</b></span>
        <span>Clubnächte <b>✦</b></span>
      </div>
    </div>

    <section class="gallery-home__intro">
      <div>
        <p class="gallery-kicker"><span></span> Erinnerungen</p>
        <h2>Deine Nacht.<br><em>Deine Bilder.</em></h2>
      </div>
      <div class="gallery-home__copy">
        <p>Entdecke die letzten Clubnächte, finde dich und deine Freunde wieder und teile die besten Momente.</p>
        <div class="gallery-home__actions">
          <router-link class="button button-accent" to="/gallery-overview">Alle Fotoalben <span>→</span></router-link>
          <router-link class="button button-ghost" to="/shoutout">Zum Messageboard <span>→</span></router-link>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import axios from 'axios';
import { apiUrl } from '../api';
export default {
  name: "Home",
  data() {
    return {
      galleries: [],
      loading: true,
      loadError: false
    };
  },
  computed: {
    featuredGalleries() {
      return this.galleries.slice(0, 4);
    }
  },
  mounted(){
    axios.post(apiUrl('/public-api/get/galleries/json'))
      .then(response => {
        const galleries = response.data && response.data.data ? response.data.data : [];
        this.galleries = galleries.slice().reverse();
      })
      .catch(() => {
        this.loadError = true;
      })
      .then(() => {
        this.loading = false;
      });
  },
  methods: {
    formatDate(value) {
      if (!value || value.length < 10) return 'Clubnacht';
      return value.slice(8, 10) + '.' + value.slice(5, 7) + '.' + value.slice(0, 4);
    }
  }
}
</script>
<style>
.gallery-home {
  background: #08080a;
}
.album-hero {
  position: relative;
  min-height: calc(100svh - 68px);
  overflow: hidden;
  background: #08080a;
}
.album-hero__heading {
  position: absolute;
  z-index: 5;
  top: clamp(36px, 7vh, 82px);
  right: 0;
  left: 0;
  padding: 0 24px;
  text-align: center;
  pointer-events: none;
}
.album-hero__heading p,
.gallery-kicker {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: rgba(255,255,255,.74);
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .2em;
  text-transform: uppercase;
}
.album-hero__heading p span,
.gallery-kicker span {
  width: 22px;
  height: 3px;
  background: #cc2cce;
}
.album-hero__heading h1 {
  margin-top: 12px;
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: clamp(38px, 5vw, 72px);
  font-weight: 700;
  line-height: .94;
  text-transform: uppercase;
  text-shadow: 0 3px 28px rgba(0,0,0,.5);
}
.album-hero__heading h1 em {
  color: #f5ddf6;
  font-style: normal;
  text-transform: none;
}
.album-hero__grid {
  min-height: calc(100svh - 68px);
  display: flex;
  overflow: hidden;
}
.album-hero__panel {
  position: relative;
  min-width: 0;
  flex: 1 1 0;
  min-height: calc(100svh - 68px);
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  background: #17171b;
  transition: flex-grow .42s cubic-bezier(.2,.7,.2,1);
}
.album-hero__panel + .album-hero__panel {
  border-left: 1px solid rgba(255,255,255,.22);
}
.album-hero__panel img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.01);
  transition: transform .7s cubic-bezier(.2,.7,.2,1);
}
.album-hero__panel:hover {
  flex-grow: 1.55;
}
.album-hero__panel:hover img {
  transform: scale(1.06);
}
.album-hero__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(5,5,7,.58), rgba(5,5,7,.13) 40%, rgba(5,5,7,.94));
}
.album-hero__number {
  position: absolute;
  top: 28px;
  right: 25px;
  color: rgba(255,255,255,.62);
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
}
.album-hero__content {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: clamp(24px, 3vw, 46px);
}
.album-hero__content > p {
  margin-bottom: 10px;
  color: #dcff21;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .12em;
  text-transform: uppercase;
}
.album-hero__content h2 {
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: clamp(22px, 2.3vw, 38px);
  font-weight: 700;
  line-height: .98;
  text-transform: uppercase;
}
.album-hero__cta {
  margin-top: 22px;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  opacity: 0;
  border-bottom: 1px solid rgba(255,255,255,.5);
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  transform: translateY(8px);
  transition: opacity .3s, transform .3s;
}
.album-hero__panel:hover .album-hero__cta {
  opacity: 1;
  transform: translateY(0);
}
.album-hero__placeholder {
  pointer-events: none;
}
.album-hero__skeleton {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(110deg, transparent 18%, rgba(255,255,255,.06) 35%, transparent 52%) -200% 0 / 200% 100%,
    linear-gradient(180deg, #151218, #0d0b0f);
  animation: heroShimmer 1.45s ease-in-out infinite;
}
@keyframes heroShimmer {
  to { background-position: 200% 0, 0 0; }
}
.album-ticker {
  overflow: hidden;
  color: #08080a;
  background: #de03d5;
}
.album-ticker > div {
  width: max-content;
  padding: 13px 0;
  display: flex;
  animation: albumTicker 24s linear infinite;
}
.album-ticker span {
  padding: 0 22px;
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .1em;
  text-transform: uppercase;
}
.album-ticker b {
  margin-left: 32px;
}
@keyframes albumTicker {
  to { transform: translateX(-50%); }
}
.gallery-home__intro {
  max-width: 1180px;
  margin: 0 auto;
  padding: clamp(72px, 10vw, 132px) clamp(24px, 6vw, 80px);
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, .72fr);
  gap: clamp(50px, 9vw, 130px);
  align-items: end;
}
.gallery-home__intro .gallery-kicker {
  justify-content: flex-start;
  margin-bottom: 20px;
}
.gallery-home__intro h2 {
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: clamp(42px, 6vw, 78px);
  font-weight: 700;
  line-height: .94;
  text-transform: uppercase;
}
.gallery-home__intro h2 em {
  color: #cc2cce;
  font-style: normal;
  text-transform: none;
}
.gallery-home__copy > p {
  color: rgba(255,255,255,.68);
  font-size: 18px;
  line-height: 1.75;
}
.gallery-home__actions {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
@media (min-width: 1101px) {
  .album-hero__grid {
    --slant: 44px;
  }
  .album-hero__panel {
    clip-path: polygon(var(--slant) 0, 100% 0, calc(100% - var(--slant)) 100%, 0 100%);
  }
  .album-hero__panel:first-child {
    clip-path: polygon(0 0, 100% 0, calc(100% - var(--slant)) 100%, 0 100%);
  }
  .album-hero__panel:last-child {
    clip-path: polygon(var(--slant) 0, 100% 0, 100% 100%, 0 100%);
  }
  .album-hero__panel + .album-hero__panel {
    margin-left: calc(-1 * var(--slant));
    padding-left: var(--slant);
  }
}
@media (max-width: 900px) {
  .album-hero,
  .album-hero__grid {
    min-height: auto;
  }
  .album-hero__heading {
    top: 30px;
  }
  .album-hero__grid {
    padding-top: 140px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .album-hero__panel {
    min-height: 46vh;
  }
  .album-hero__cta {
    opacity: 1;
    transform: none;
  }
  .gallery-home__intro {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .album-hero__grid {
    grid-template-columns: 1fr;
  }
  .album-hero__panel {
    min-height: 52vh;
  }
  .album-hero__heading h1 {
    font-size: 34px;
  }
}
</style>